import styled from "styled-components";
import { colors } from "../../../components/common/element/elements.js";

export const Styles = styled.div`
  .university-details-page {
    .university-details-section {
      padding: 70px 0;

      .loading-state {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 12px;
        padding: 80px 0;
        color: ${colors.text3};

        span {
          font-size: 15px;
        }
      }

      .university-card {
        background: #fff;
        border-radius: 8px;
        border: 1px solid ${colors.border1};
        box-shadow: 0 15px 45px rgba(0, 0, 0, 0.08);
        padding: 32px;

        .header {
          display: flex;
          flex-wrap: wrap;
          gap: 30px;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;

          .title-block {
            flex: 1 1 280px;

            h2 {
              font-size: 28px;
              font-weight: 700;
              margin-bottom: 12px;
              color: ${colors.black1};
            }

            .meta {
              display: flex;
              gap: 16px;
              flex-wrap: wrap;
              font-size: 14px;
              color: ${colors.text3};

              strong {
                color: ${colors.black2};
              }
            }
          }

          .image-wrapper {
            flex: 0 0 280px;
            max-width: 100%;

            img {
              width: 100%;
              border-radius: 8px;
              border: 1px solid ${colors.border1};
              object-fit: cover;
              max-height: 200px;
            }
          }
        }

        .content {
          border-top: 1px solid ${colors.border2};
          padding-top: 24px;

          .description {
            font-size: 16px;
            line-height: 1.7;
            color: ${colors.text1};

            h1,
            h2,
            h3,
            h4,
            h5,
            h6 {
              margin-top: 24px;
              margin-bottom: 12px;
              color: ${colors.black1};
            }

            p {
              margin-bottom: 16px;
            }

            ul,
            ol {
              margin: 0 0 16px 24px;
            }
          }
        }

        .footer-actions {
          margin-top: 30px;
          display: flex;
          justify-content: flex-start;
        }
      }
    }

    @media (max-width: 767px) {
      .university-details-section {
        padding: 40px 0;

        .university-card {
          padding: 24px;

          .header {
            .title-block h2 {
              font-size: 22px;
            }

            .image-wrapper {
              flex: 1 1 100%;

              img {
                max-height: none;
              }
            }
          }
        }
      }
    }
  }
`;

